<template>
  <div class="loading-overlay" v-if="showLoader">
    <div class="bounce-loader">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</template>
<script>
import Api from '@/services/api';

const { api } = Api;

const blacklist = [
  '/articles/customer-customized-articles',
  '/articles/newly-added-articles',
];

export default {
  name: 'Loader',
  data() {
    return {
      showLoader: false,
      requests: [],
    };
  },
  mounted() {
    api.interceptors.request.use(
      (config) => {
        // Then
        if (blacklist.indexOf(config.url) === -1) {
          this.requests.push(config);
        }
        this.showLoader = true;
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return config;
      },
      (error) => {
        // Catch
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return Promise.reject(error);
      },
    );

    api.interceptors.response.use(
      (response) => {
        // Then
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return response;
      },
      (error) => {
        // Catch
        this.showLoader = false;
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return Promise.reject(error);
      },
    );
  },
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  background: transparent;
}
</style>
